import _defineProperty from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty";
import "vant/lib/toast/style";
import _Toast from "vant/lib/toast";
import _Promise from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/core-js/promise";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator";

var _actions;

import * as types from "@/store/constants/types";
import PalmReadClient from "@/api/palmRead/index";
import routerTempHelpers from "@/utils/routerTempHelpers";
import HoroScopeClient from "@/api/horoScope";
import GeneralUtilsHelper from "@/utils/generalUtils";
import { i18n } from "@/i18n/i18n-setup";
import { getLang } from "@/api/utils/apiHelper";
import { sendMapEvent } from "@/utils/analytics";

var randomNum = function randomNum(arr) {
  return Math.floor(Math.random() * arr.length);
};

var actions = (_actions = {}, _defineProperty(_actions, types.FETCH_PALM_PRINT_DATA, function () {
  var _ref2 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee(_ref, payload) {
    var state, commit, dispatch, lang, result;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            state = _ref.state, commit = _ref.commit, dispatch = _ref.dispatch;
            _context.prev = 1;
            lang = getLang();
            _context.next = 5;
            return PalmReadClient.req_palm_print(lang);

          case 5:
            result = _context.sent;
            console.log("FETCH_PALM_PRINT_DATA", result);
            commit(types.FETCH_PALM_PRINT_DATA, result);
            _context.next = 14;
            break;

          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](1);
            console.log("FETCH_PALM_PRINT_DATA error", _context.t0);

            if (payload) {
              commit(types.SHOW_NETWORK_TOAST, function () {
                dispatch(types.ROUTER_GO_BACK, -1);
              });
            }

          case 14:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 10]]);
  }));

  return function (_x, _x2) {
    return _ref2.apply(this, arguments);
  };
}()), _defineProperty(_actions, types.FETCH_FACE_READING_DATA, function () {
  var _ref4 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee2(_ref3, payload) {
    var state, commit, dispatch, lang, result;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            state = _ref3.state, commit = _ref3.commit, dispatch = _ref3.dispatch;
            _context2.prev = 1;
            lang = getLang();
            _context2.next = 5;
            return PalmReadClient.req_face_reading(lang);

          case 5:
            result = _context2.sent;
            console.log("FETCH_FACE_READING_DATA", result);
            commit(types.FETCH_FACE_READING_DATA, result);
            _context2.next = 14;
            break;

          case 10:
            _context2.prev = 10;
            _context2.t0 = _context2["catch"](1);
            console.log("FETCH_FACE_READING_DATA error", _context2.t0);

            if (payload) {
              commit(types.SHOW_NETWORK_TOAST, function () {
                dispatch(types.ROUTER_GO_BACK, -1);
              });
            }

          case 14:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[1, 10]]);
  }));

  return function (_x3, _x4) {
    return _ref4.apply(this, arguments);
  };
}()), _defineProperty(_actions, types.PALMISTRY, function () {
  var _ref6 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee6(_ref5, payload) {
    var state, commit, dispatch, getters;
    return regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            state = _ref5.state, commit = _ref5.commit, dispatch = _ref5.dispatch, getters = _ref5.getters;
            return _context6.abrupt("return", new _Promise(
            /*#__PURE__*/
            function () {
              var _ref7 = _asyncToGenerator(
              /*#__PURE__*/
              regeneratorRuntime.mark(function _callee5(resolve, reject) {
                var cameraResult, getResult, maskState;
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                  while (1) {
                    switch (_context5.prev = _context5.next) {
                      case 0:
                        _context5.prev = 0;
                        _context5.next = 3;
                        return dispatch(types.TAKE_PHOTO_EX, {
                          top: {
                            backgroundColor: "#603BF3",
                            text: i18n.t("common.camera.right_hand"),
                            textColor: "#ffffff"
                          },
                          type: "hand_right",
                          bottom: {
                            text: i18n.t("common.camera.frame_text")
                          },
                          title: {
                            text: i18n.t("home_page.main_function_list.palmistry")
                          }
                        });

                      case 3:
                        cameraResult = _context5.sent;

                        getResult =
                        /*#__PURE__*/
                        function () {
                          var _ref8 = _asyncToGenerator(
                          /*#__PURE__*/
                          regeneratorRuntime.mark(function _callee4(callbackData) {
                            var value, base64, syncPalmResult, asyncPalmResult, keyWordsList, keyWords1, keyWords2, handleData;
                            return regeneratorRuntime.wrap(function _callee4$(_context4) {
                              while (1) {
                                switch (_context4.prev = _context4.next) {
                                  case 0:
                                    value = callbackData.value, base64 = callbackData.base64;

                                    syncPalmResult = function syncPalmResult(sync_params) {
                                      console.log("sync_params", sync_params);
                                      return new _Promise(
                                      /*#__PURE__*/
                                      function () {
                                        var _ref9 = _asyncToGenerator(
                                        /*#__PURE__*/
                                        regeneratorRuntime.mark(function _callee3(sync_resolve, sync_reject) {
                                          var palm_result;
                                          return regeneratorRuntime.wrap(function _callee3$(_context3) {
                                            while (1) {
                                              switch (_context3.prev = _context3.next) {
                                                case 0:
                                                  _context3.prev = 0;
                                                  _context3.next = 3;
                                                  return HoroScopeClient.req_hands_today(sync_params);

                                                case 3:
                                                  palm_result = _context3.sent;
                                                  console.log("palm_result", palm_result);
                                                  handleData(palm_result);
                                                  sync_resolve(true);
                                                  _context3.next = 15;
                                                  break;

                                                case 9:
                                                  _context3.prev = 9;
                                                  _context3.t0 = _context3["catch"](0);

                                                  _Toast(i18n.t("toast.minor_prablem"));

                                                  commit(types.UPDATE_LOADING_STATUS, false);
                                                  sendMapEvent("uia_fill_in_Palmistry", {
                                                    failed: _context3.t0
                                                  });
                                                  sync_reject(false);

                                                case 15:
                                                case "end":
                                                  return _context3.stop();
                                              }
                                            }
                                          }, _callee3, null, [[0, 9]]);
                                        }));

                                        return function (_x10, _x11) {
                                          return _ref9.apply(this, arguments);
                                        };
                                      }());
                                    };

                                    asyncPalmResult = function asyncPalmResult(async_params) {
                                      HoroScopeClient.req_hands_today(async_params).then(function (async_result) {
                                        handleData(async_result);
                                      }).catch(function (e) {
                                        _Promise.reject(e);
                                      });
                                    };

                                    commit(types.UPDATE_LOADING_STATUS, true);
                                    keyWordsList = [i18n.t("daily_plamistry.keywords_List[0]"), i18n.t("daily_plamistry.keywords_List[1]"), i18n.t("daily_plamistry.keywords_List[2]"), i18n.t("daily_plamistry.keywords_List[3]")];
                                    keyWords1 = keyWordsList.splice(randomNum(keyWordsList), 1)[0];
                                    keyWords2 = keyWordsList.splice(randomNum(keyWordsList), 1)[0];

                                    handleData = function handleData(result) {
                                      console.log("handleData", result);

                                      if (result.status === 200) {
                                        // 重置缓存数据
                                        commit(types.UPDATE_DAILY_PLAMISTRY_DATA, null);
                                        commit(types.UPDATE_DAILY_PLAMISTRY_DATA, {
                                          resultData: result.data,
                                          imgUrl: "data:image/jpeg;base64," + base64,
                                          gender: value.gender,
                                          keyWords1: keyWords1,
                                          keyWords2: keyWords2,
                                          nickName: value.nickName
                                        });
                                      } else {
                                        _Toast(i18n.t("toast.minor_prablem"));
                                      }
                                    };

                                    if (!GeneralUtilsHelper.isVip()) {
                                      _context4.next = 13;
                                      break;
                                    }

                                    _context4.next = 11;
                                    return syncPalmResult(value.horoScopeIndex);

                                  case 11:
                                    _context4.next = 14;
                                    break;

                                  case 13:
                                    asyncPalmResult(value.horoScopeIndex);

                                  case 14:
                                    sendMapEvent("uia_fill_in_Palmistry", {
                                      key: "success"
                                    });
                                    dispatch(types.ROUTER_PUSH, {
                                      name: "palmistryResult",
                                      params: {
                                        routerTransition: "forward",
                                        showVipRightNow: true
                                      },
                                      query: {
                                        tempKey: routerTempHelpers.setQueryTemp({
                                          syncGetResult: function syncGetResult() {
                                            return syncPalmResult(value.horoScopeIndex);
                                          },
                                          imgUrl: "data:image/jpeg;base64," + base64,
                                          gender: value.gender,
                                          keyWords1: keyWords1,
                                          keyWords2: keyWords2,
                                          nickName: value.nickName
                                        })
                                      }
                                    });
                                    commit(types.UPDATE_LOADING_STATUS, false);

                                  case 17:
                                  case "end":
                                    return _context4.stop();
                                }
                              }
                            }, _callee4);
                          }));

                          return function getResult(_x9) {
                            return _ref8.apply(this, arguments);
                          };
                        }(); // 重置mask状态


                        maskState = getters[types.GETTER_TEMP_RESULT_BY_NAME]("maskShow");
                        !maskState && commit(types.UPDATE_RESULT_BY_NAME, {
                          name: "maskShow",
                          result: true
                        }); //跳转路由到确定页面:

                        dispatch(types.ROUTER_PUSH, {
                          name: "confirmPhoto",
                          params: {
                            transitionType: "static"
                          },
                          query: {
                            tempKey: routerTempHelpers.setQueryTemp({
                              nextStepFunction: function nextStepFunction(result) {
                                //告诉下个页面next to do
                                getResult(result);
                              },
                              imageData: {
                                picUrl: cameraResult.base64,
                                picFileUrl: cameraResult.filePath
                              },
                              confirmShowScaning: true,
                              isShowHand: true,
                              title: "Daily Palm",
                              genderShow: true,
                              functionType: "daily_palmistry"
                            })
                          }
                        });
                        _context5.next = 14;
                        break;

                      case 10:
                        _context5.prev = 10;
                        _context5.t0 = _context5["catch"](0);
                        commit(types.UPDATE_LOADING_STATUS, false);
                        reject(_context5.t0);

                      case 14:
                      case "end":
                        return _context5.stop();
                    }
                  }
                }, _callee5, null, [[0, 10]]);
              }));

              return function (_x7, _x8) {
                return _ref7.apply(this, arguments);
              };
            }()));

          case 2:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));

  return function (_x5, _x6) {
    return _ref6.apply(this, arguments);
  };
}()), _defineProperty(_actions, types.LOVE_COMSULTANT, function () {
  var _ref11 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee9(_ref10, payload) {
    var state, commit, dispatch;
    return regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            state = _ref10.state, commit = _ref10.commit, dispatch = _ref10.dispatch;
            return _context9.abrupt("return", new _Promise(
            /*#__PURE__*/
            function () {
              var _ref12 = _asyncToGenerator(
              /*#__PURE__*/
              regeneratorRuntime.mark(function _callee8(resolve, reject) {
                var cameraResult, getResult;
                return regeneratorRuntime.wrap(function _callee8$(_context8) {
                  while (1) {
                    switch (_context8.prev = _context8.next) {
                      case 0:
                        _context8.prev = 0;
                        _context8.next = 3;
                        return dispatch(types.TAKE_PHOTO_EX, {
                          top: {
                            backgroundColor: "#603BF3",
                            text: i18n.t("common.camera.right_hand"),
                            textColor: "#ffffff"
                          },
                          type: "hand_right",
                          bottom: {
                            text: i18n.t("common.camera.frame_text")
                          },
                          title: {
                            text: i18n.t("home_page.main_function_list.love_consultant")
                          }
                        });

                      case 3:
                        cameraResult = _context8.sent;

                        getResult =
                        /*#__PURE__*/
                        function () {
                          var _ref13 = _asyncToGenerator(
                          /*#__PURE__*/
                          regeneratorRuntime.mark(function _callee7(callbackData) {
                            var value, base64, result;
                            return regeneratorRuntime.wrap(function _callee7$(_context7) {
                              while (1) {
                                switch (_context7.prev = _context7.next) {
                                  case 0:
                                    _context7.prev = 0;
                                    value = callbackData.value, base64 = callbackData.base64;
                                    commit(types.UPDATE_LOADING_STATUS, true);
                                    _context7.next = 5;
                                    return HoroScopeClient.req_love_report(value.horoScopeIndex, value.birthdayMonth, value.birthdayDay);

                                  case 5:
                                    result = _context7.sent;
                                    commit(types.UPDATE_LOADING_STATUS, false);

                                    if (result.status === 200) {
                                      dispatch(types.ROUTER_PUSH, {
                                        name: "loveConsultant",
                                        query: {
                                          tempKey: routerTempHelpers.setQueryTemp({
                                            resultData: result.data,
                                            imgUrl: "data:image/jpeg;base64," + base64,
                                            gender: value.gender,
                                            nickName: value.nickName
                                          })
                                        },
                                        params: {
                                          routerTransition: "forward",
                                          showVipRightNow: true
                                        }
                                      });
                                    } else {
                                      _Toast(i18n.t("toast.minor_prablem"));
                                    }

                                    _context7.next = 14;
                                    break;

                                  case 10:
                                    _context7.prev = 10;
                                    _context7.t0 = _context7["catch"](0);

                                    _Toast(i18n.t("toast.minor_prablem"));

                                    commit(types.UPDATE_LOADING_STATUS, false);

                                  case 14:
                                  case "end":
                                    return _context7.stop();
                                }
                              }
                            }, _callee7, null, [[0, 10]]);
                          }));

                          return function getResult(_x16) {
                            return _ref13.apply(this, arguments);
                          };
                        }(); //跳转路由到确定页面:


                        dispatch(types.ROUTER_PUSH, {
                          name: "confirmPhoto",
                          params: {
                            transitionType: "static"
                          },
                          query: {
                            tempKey: routerTempHelpers.setQueryTemp({
                              nextStepFunction: function nextStepFunction(result) {
                                //告诉下个页面next to do
                                getResult(result);
                              },
                              imageData: {
                                picUrl: cameraResult.base64,
                                picFileUrl: cameraResult.filePath
                              },
                              confirmShowScaning: true,
                              isShowHand: true,
                              title: "Love Consultant",
                              genderShow: true
                            })
                          }
                        });
                        _context8.next = 10;
                        break;

                      case 8:
                        _context8.prev = 8;
                        _context8.t0 = _context8["catch"](0);

                      case 10:
                      case "end":
                        return _context8.stop();
                    }
                  }
                }, _callee8, null, [[0, 8]]);
              }));

              return function (_x14, _x15) {
                return _ref12.apply(this, arguments);
              };
            }()));

          case 2:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9);
  }));

  return function (_x12, _x13) {
    return _ref11.apply(this, arguments);
  };
}()), _defineProperty(_actions, types.WEALTH_FORE_CAST, function () {
  var _ref15 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee12(_ref14, payload) {
    var state, commit, dispatch;
    return regeneratorRuntime.wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            state = _ref14.state, commit = _ref14.commit, dispatch = _ref14.dispatch;
            return _context12.abrupt("return", new _Promise(
            /*#__PURE__*/
            function () {
              var _ref16 = _asyncToGenerator(
              /*#__PURE__*/
              regeneratorRuntime.mark(function _callee11(resolve, reject) {
                var cameraResult, getResult;
                return regeneratorRuntime.wrap(function _callee11$(_context11) {
                  while (1) {
                    switch (_context11.prev = _context11.next) {
                      case 0:
                        _context11.prev = 0;
                        _context11.next = 3;
                        return dispatch(types.TAKE_PHOTO_EX, {
                          top: {
                            backgroundColor: "#603BF3",
                            text: i18n.t("common.camera.right_hand"),
                            textColor: "#ffffff"
                          },
                          type: "hand_right",
                          bottom: {
                            text: i18n.t("common.camera.frame_text")
                          },
                          title: {
                            text: i18n.t("home_page.main_function_list.wealth_forecast")
                          }
                        });

                      case 3:
                        cameraResult = _context11.sent;

                        getResult =
                        /*#__PURE__*/
                        function () {
                          var _ref17 = _asyncToGenerator(
                          /*#__PURE__*/
                          regeneratorRuntime.mark(function _callee10(callbackData) {
                            var value, base64, result;
                            return regeneratorRuntime.wrap(function _callee10$(_context10) {
                              while (1) {
                                switch (_context10.prev = _context10.next) {
                                  case 0:
                                    _context10.prev = 0;
                                    value = callbackData.value, base64 = callbackData.base64;
                                    commit(types.UPDATE_LOADING_STATUS, true);
                                    _context10.next = 5;
                                    return HoroScopeClient.req_wealth_report(value.horoScopeIndex, value.birthdayMonth, value.birthdayDay);

                                  case 5:
                                    result = _context10.sent;
                                    commit(types.UPDATE_LOADING_STATUS, false);

                                    if (result.status === 200) {
                                      dispatch(types.ROUTER_PUSH, {
                                        name: "wealthForecast",
                                        query: {
                                          tempKey: routerTempHelpers.setQueryTemp({
                                            resultData: result.data,
                                            imgUrl: "data:image/jpeg;base64," + base64,
                                            gender: value.gender,
                                            nickName: value.nickName
                                          })
                                        },
                                        params: {
                                          routerTransition: "forward",
                                          showVipRightNow: true
                                        }
                                      });
                                    } else {
                                      _Toast(i18n.t("toast.minor_prablem"));
                                    }

                                    _context10.next = 14;
                                    break;

                                  case 10:
                                    _context10.prev = 10;
                                    _context10.t0 = _context10["catch"](0);

                                    _Toast(i18n.t("toast.minor_prablem"));

                                    commit(types.UPDATE_LOADING_STATUS, false);

                                  case 14:
                                  case "end":
                                    return _context10.stop();
                                }
                              }
                            }, _callee10, null, [[0, 10]]);
                          }));

                          return function getResult(_x21) {
                            return _ref17.apply(this, arguments);
                          };
                        }(); //跳转路由到确定页面:


                        dispatch(types.ROUTER_PUSH, {
                          name: "confirmPhoto",
                          params: {
                            transitionType: "static"
                          },
                          query: {
                            tempKey: routerTempHelpers.setQueryTemp({
                              nextStepFunction: function nextStepFunction(result) {
                                //告诉下个页面next to do
                                getResult(result);
                              },
                              imageData: {
                                picUrl: cameraResult.base64,
                                picFileUrl: cameraResult.filePath
                              },
                              confirmShowScaning: true,
                              isShowHand: true,
                              title: "Wealth Forecast",
                              genderShow: true
                            })
                          }
                        });
                        _context11.next = 11;
                        break;

                      case 8:
                        _context11.prev = 8;
                        _context11.t0 = _context11["catch"](0);
                        reject(_context11.t0);

                      case 11:
                      case "end":
                        return _context11.stop();
                    }
                  }
                }, _callee11, null, [[0, 8]]);
              }));

              return function (_x19, _x20) {
                return _ref16.apply(this, arguments);
              };
            }()));

          case 2:
          case "end":
            return _context12.stop();
        }
      }
    }, _callee12);
  }));

  return function (_x17, _x18) {
    return _ref15.apply(this, arguments);
  };
}()), _actions);
export default actions;